/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from 'prop-types';

const CategoryCard = ({ name, image, isSelected, onClick }) => {
  return (
    <div className="flex flex-col mt-1.5 w-full whitespace-nowrap search">
      <div className={`flex cursor-pointer relative flex-col px-10 py-7 aspect-[4.097] w-[381px] max-md:px-5 transition-height duration-300 hover:py-20 card ${isSelected ? 'border border-white' : ''}`} onClick={onClick}>
        <img
          loading="lazy"
          src={image}
          alt={`${name} category`}
          className="object-cover absolute inset-0 size-full"
        />
        <span className="relative z-10 text-hover">{name}</span>
      </div>
    </div>
  );
};

CategoryCard.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default CategoryCard;
